// ----------------------------------------------------------------------------
// Component: Tab
// ----------------------------------------------------------------------------
//
// TAB component with desktop tab functionality.
//
// Requires the following structure:
// .js-tab__item
//     .js-tab__button
//     .js-tab__content
//
// When the button is clicked, 'isOpen' class is added/removed for all three
// elements.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/icon/icon';

// Styles
import './_tabs.scss';


// -------------------------------------
// Variables
// -------------------------------------

const TAB_MOBILE            = '.js-tab--stores--mobile';
const TAB_BUTTON_MOBILE     = '.js-tab--stores__button--mobile';
const TAB_ITEM_MOBILE       = '.js-tab--stores__item--mobile';
const TAB_CONTENT_MOBILE    = '.js-tab--stores__content--mobile';
const TAB_TITLE_MOBILE      = '.js-tab--stores__title--mobile';
const TAB_BUTTON_DESKTOP    = '.js-tab--stores__button--desktop';
const TAB_CONTENT_DESKTOP   = '.js-tab--stores__content--desktop';
const TABS_CONTAINER        = '.js-tabs--stores--desktop';

// Constant trigger classes
const OPEN_CLASS            = 'is-open';

// Button Group
const BUTTON_GROUP_MOBILE   = $(TAB_BUTTON_MOBILE);
const BUTTON_GROUP_DESKTOP  = $(TAB_BUTTON_DESKTOP);

// TODO: Switch back to live store API on launch
let INVENTORY_API_URL = $('.accordion--find-in-store').attr('data-inventory-url'); // Live store API

if (Shopify.shop == "duerdevusd.myshopify.com") {
    INVENTORY_API_URL = 'https://eorqeg2rvhksi5r.m.pipedream.net/?id='; // Test API
}

// -------------------------------------
// Helper Functions
// -------------------------------------

function handleMobileTab(tab) {
    tab.$item.parent().find('.' + OPEN_CLASS).removeClass(OPEN_CLASS);

    tab.$item.parent().find(TAB_CONTENT_MOBILE).css('overflow', 'hidden');

    tab.$item.parent().find(TAB_BUTTON_MOBILE).attr('aria-expanded', 'false');

    tab.$item.parent().find(TAB_CONTENT_MOBILE + " a").attr('tabindex', -1);

    if (tab.isOpening) {
        tab.$button
            .add(tab.$item)
            .add(tab.$content)
            .addClass(OPEN_CLASS);

        tab.$button.attr('aria-expanded', 'true');
        tab.$content.attr('hidden', false);
        tab.$content.find('a').attr('tabindex', null);

        // This allows select boxes to flow out after it's opened
        setTimeout(function() {
            tab.$content.css('overflow', 'visible');
        }, 200);
    }
}

function getInventory(tab) {
    const findInStoreContainer = tab.parents('.accordion--find-in-store');
    
    if (!tab.hasClass(OPEN_CLASS) && INVENTORY_API_URL != "") {
        let selected_store = tab.attr('data-store-id');
        localStorage.setItem('selected_store', selected_store);
        let current_variant_id = findInStoreContainer.attr('data-current-variant');

        $.get(INVENTORY_API_URL+current_variant_id, function(data, status){

            var inventoryLevel = data.inventory_levels.find(function (level) {
              return level.location_id.toString() === selected_store
            })

            if (!inventoryLevel) {
              return;
            }

            $('.store__available-stock').text(inventoryLevel.available);

            if (inventoryLevel.available > 0) {
                $('.find-in-store__stock-icon--out-of-stock').addClass('hide');
                $('.find-in-store__stock-icon--available').removeClass('hide');
            } else {
                $('.find-in-store__stock-icon--out-of-stock').removeClass('hide');
                $('.find-in-store__stock-icon--available').addClass('hide');
            }
        })
    }
}

function tabOpen(tab) {
    const targetTab = tab.attr('aria-controls');
    const panel = $("#"+targetTab+"");

    if (!tab.hasClass(OPEN_CLASS)) {
        // Close all other Panels
        tab.siblings().find(TAB_BUTTON_DESKTOP).attr("aria-selected", "false");
        tab.siblings().find(TAB_BUTTON_DESKTOP).attr("tabindex", "-1");
        tab.siblings().removeClass(OPEN_CLASS);

        // Toggle new panel
        tab.addClass(OPEN_CLASS);
        tab.attr("aria-selected", "true");
        tab.attr("tabindex", null);
        panel.addClass(OPEN_CLASS);
    }
}


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {

    $('.button--find-in-store').on('click', function() {
        const $PRODUCT_FORM          = $(this).closest(".product__form");
        const $PRODUCT_CONTAINER     = $PRODUCT_FORM.find("#productStickyContainer");
        const $PRODUCT_ATC_BUTTON    = $PRODUCT_CONTAINER.find(".btn--add-to-cart--quick");
        
        //Prompts the user to select an option
        if($PRODUCT_ATC_BUTTON.hasClass('btn--select-size')) {
            const $atc_error_messge = $PRODUCT_ATC_BUTTON.parents('.product__form').children('.add-to-cart__error-wrapper');
            if( $atc_error_messge.length ) {
                $atc_error_messge.addClass("error-show");
                $(this).addClass("js-accordion__button--contidioned");
                return false;
            }
        } else if($(this).hasClass("js-accordion__button--contidioned")) {
            $(this).removeClass("js-accordion__button--contidioned");
            //Re-runs Accordion opening function. 
            $(this).trigger("click");
            return false;
        }
    
        if(localStorage.getItem("selected_store") !== null) {
            var default_selected_store = localStorage.getItem("selected_store");
            getInventory($('[data-store-id="'+default_selected_store+'"]'));
            tabOpen($('[data-store-id="'+default_selected_store+'"]'));
        }
    })

    $(TAB_CONTENT_MOBILE + " a").attr('tabindex', -1);

    $(TAB_BUTTON_MOBILE).on('click keydown', function(e){
        /**
         * click: Check state of the tab item then pass on an action
         *
         * @param {Event} e
         * @return void
         */
        //e.preventDefault();

        // Store $this for reference
        var $this = $(e.target);

        // Store elements as an object
        var tab = {};

        tab.$button    = $this;
        tab.$item      = $this.parents(TAB_ITEM_MOBILE);
        tab.$title     = $this.parents(TAB_TITLE_MOBILE);
        tab.$content   = tab.$title.siblings(TAB_CONTENT_MOBILE);
        tab.isOpening  = !$this.hasClass(OPEN_CLASS);
        tab.$container = $this.closest(TAB_MOBILE);

        // Collapse any open sibling & children tabs if data attribute set to true
        if (e.type === 'click') {
            e.preventDefault();
            handleMobileTab(tab);
        }
        else if (e.type === 'keydown') {
            let key = e.which.toString();
            if (key.match(/35|36|38|40/)) {
                e.preventDefault();
                let index = $.inArray(e.target, BUTTON_GROUP_MOBILE);
                let length = BUTTON_GROUP_MOBILE.length;
                let newIndex;
                switch(key) {
                    case '38': // Up
                        newIndex = (index + length + -1) % length;
                        BUTTON_GROUP_MOBILE[newIndex].focus();
                        break;
                    case '40': // Down
                        newIndex = (index + length + 1) % length;
                        BUTTON_GROUP_MOBILE[newIndex].focus();
                        break;
                    case '35': // End
                        BUTTON_GROUP_MOBILE[length - 1].focus();
                        break;
                    case '36': // Home
                        BUTTON_GROUP_MOBILE[0].focus();
                        break;
                }
            }
        }
    });


    // Open first tab on page load
    $(TABS_CONTAINER).each(function(index) {
        $(this).find(TAB_BUTTON_DESKTOP).attr("tabindex", "-1");
        $(this).find(TAB_BUTTON_DESKTOP).first().addClass(OPEN_CLASS);
        $(this).find(TAB_BUTTON_DESKTOP).first().attr("aria-selected", "true");
        $(this).find(TAB_BUTTON_DESKTOP).first().attr("tabindex", null);
        $(this).children(TAB_CONTENT_DESKTOP).first().addClass(OPEN_CLASS);
    });


    // Card opens Panel
    $(TAB_BUTTON_DESKTOP).on('click keydown', function(e) {
        if (e.type === 'click') {
            e.preventDefault();
            getInventory($(this));
            tabOpen($(this));
        }
        else if (e.type === 'keydown') {
            let key = e.which.toString();
            if (key.match(/35|36|37|39/)) {
                e.preventDefault();
                let index = $.inArray(e.target, BUTTON_GROUP_DESKTOP);
                let length = BUTTON_GROUP_DESKTOP.length;
                let newIndex;
                switch(key) {
                    case '37': // Up
                        newIndex = (index + length + -1) % length;
                        BUTTON_GROUP_DESKTOP[newIndex].focus();
                        getInventory($(BUTTON_GROUP_DESKTOP[newIndex]));
                        tabOpen($(BUTTON_GROUP_DESKTOP[newIndex]));
                        break;
                    case '39': // Down
                        newIndex = (index + length + 1) % length;
                        BUTTON_GROUP_DESKTOP[newIndex].focus();
                        getInventory($(BUTTON_GROUP_DESKTOP[newIndex]));
                        tabOpen($(BUTTON_GROUP_DESKTOP[newIndex]));
                        break;
                    case '35': // End
                        BUTTON_GROUP_DESKTOP[length - 1].focus();
                        getInventory($(BUTTON_GROUP_DESKTOP[length - 1]));
                        tabOpen($(BUTTON_GROUP_DESKTOP[length - 1]));
                        break;
                    case '36': // Home
                        BUTTON_GROUP_DESKTOP[0].focus();
                        getInventory($(BUTTON_GROUP_DESKTOP[0]));
                        tabOpen($(BUTTON_GROUP_DESKTOP[0]));
                        break;
                }
            } else {
                return true;
            }
        }
    });
});
